import { NETOWRK_ICONS, UNKNOWN_KEY } from '@/config';

function getIconByNetwork(network: string) {
  const iconSrc = NETOWRK_ICONS[network];

  if (!iconSrc) {
    return NETOWRK_ICONS[UNKNOWN_KEY];
  }

  return iconSrc;
}

export default getIconByNetwork;
